// extracted by css-extract-rspack-plugin
module.exports =  {"root":"OCRScopeJobDetailBodyLegendInformation__root___E8Y8k","content":"OCRScopeJobDetailBodyLegendInformation__content___BjKM7"};